import React, { Component } from 'react'
import MapView from 'components/MapHighmaps'
import { translate } from 'react-i18next'
import { getApiData,resetQuery } from 'helpers/api'
import { DATASOURCE } from 'Constants'
import { connect } from 'react-redux'
import { Dimmer, Loader, Grid, Statistic, Popup } from 'semantic-ui-react'
import CardWrapper from 'screens/common/CardWrapper'
import qs from 'query-string'

class AssetMap extends Component {
  constructor(props) {
    super(props);

    this.state = {
      bounds:[[-90,-180],[90,180]]
    }

    this.getQueryBounds = this.getQueryBounds.bind(this);
    this.seriesClickCallback = this.seriesClickCallback.bind(this);
  }

  lastPropertyCount = 0;

  getQueryBounds() {
    let params = {};
    params.topRightLat = this.state.bounds[1][0];
    params.topRightLon = this.state.bounds[1][1];
    params.bottomLeftLat = this.state.bounds[0][0];
    params.bottomLeftLon = this.state.bounds[0][1];
    return params;
  }

  componentDidMount() {
    getApiData(DATASOURCE.GEOCOUNT,this.props.location.search,this.getQueryBounds());
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.search !== prevProps.location.search) {
      let p1 = qs.parse(this.props.location.search);
      let p2 = qs.parse(prevProps.location.search);
      if (p1.timePeriod !== p2.timePeriod || p1.tid !== p2.tid) {
        getApiData(DATASOURCE.GEOCOUNT,this.props.location.search,this.getQueryBounds());
      }
    }
  }

  seriesClickCallback(swPoint, nePoint) {
    resetQuery(DATASOURCE.GEOCOUNT,this.props.location.search,this.getQueryBounds());
    this.setState({bounds: [[swPoint.lat,swPoint.lon],[nePoint.lat,nePoint.lon]]});
    getApiData(DATASOURCE.GEOCOUNT,this.props.location.search,this.getQueryBounds());
  }

  statSize = "small";

  render() {
    const { t } = this.props;
    return (
      <div>
        <div className="highmapComponent ui basic blurring segment">
          <MapView
            data={this.props.count}
            isDarkMode={this.state.isDarkMode}
            seriesClickCallback={this.seriesClickCallback}
            {...this.props}
          /> 
          <Dimmer active={this.props.loading} inverted>
            <Loader />
          </Dimmer>
        </div>
        <Grid centered padded stackable>
          <Grid.Column width={3}>
            <CardWrapper isLoading={this.props.loading}>
              <div style={{textAlign: "center"}}>
                <Statistic
                  label={t("Screens.Calls.Map.TotalCalls")}
                  value={this.props.totalCalls}
                  size={this.statSize}
                />
              </div>
            </CardWrapper>
          </Grid.Column>
          <Grid.Column width={3}>
            <CardWrapper isLoading={this.props.loading}>
              <div style={{textAlign: "center"}}>
                <Popup content={t("Screens.Calls.Map.UniqueCountriesTooltip")}
                  trigger={
                    <Statistic
                      label={t("Screens.Calls.Map.UniqueCountries")}
                      value={this.props.uniqueCountries}
                      size={this.statSize}
                    />
                  } 
                />
              </div>
            </CardWrapper>
          </Grid.Column>
          <Grid.Column width={3}>
            <CardWrapper isLoading={this.props.loading}>
              <div style={{textAlign: "center"}}>
                <Popup content={t("Screens.Calls.Map.UniqueCitiesTooltip")}
                  trigger={
                    <Statistic
                      label={t("Screens.Calls.Map.UniqueCities")}
                      value={this.props.uniqueCities}
                      size={this.statSize}
                    />
                  }
                />
              </div>
            </CardWrapper>
          </Grid.Column>
        </Grid>
      </div>
    )
  }
};

// REDUX STATE
const mapToProps = state => {
  return {
    count: state.geoCount.count,
    totalCalls: state.geoCount.totalCalls,
    uniqueCities: state.geoCount.uniqueCities,
    uniqueCountries: state.geoCount.uniqueCountries,
    loading: state.geoCount.loading
  }
};

export default translate()(
  connect(
    mapToProps,
    null
  )(AssetMap)
);
